import { AppUpdatesPage } from '@/pages/app-updates';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/app-updates')({
	component: AppUpdatesPage,
});
